import React, { useEffect, useState } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { useDispatch, useSelector } from 'react-redux';
import { selectTransportHubs, selectAccessToken } from '../../store/selectors';
import { getTransportHubs } from '../../store/actions';

interface ITransportHubDropdownProperties {
  selectedValue: string[];
  onChange: (event: { value: string[] }) => void;
}

const TransportHubDropdown: React.FC<ITransportHubDropdownProperties> = ({ selectedValue, onChange }) => {
  const dispatch = useDispatch();
  const transportHubs = useSelector(selectTransportHubs);
  const accessToken = useSelector(selectAccessToken);
  const [options, setOptions] = useState<{ label: string; value: string }[]>([]);

  useEffect(() => {
    if (transportHubs.length === 0 && accessToken) {
      dispatch(getTransportHubs());
    }
  }, [dispatch, accessToken]);

  useEffect(() => {
    if (transportHubs.length > 0) {
      const sortedOptions = transportHubs
        .map((transportHub) => ({
          label: `${transportHub.code} - ${transportHub.name}`,
          value: transportHub.code,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
      setOptions(sortedOptions);
    }
  }, [transportHubs]);

  return (
    <MultiSelect
      id="transportHubDropdown"
      value={selectedValue}
      options={options}
      onChange={onChange}
      placeholder="Select Airports / Bus Stops"
      display="chip"
      filter
    />
  );
};

export default TransportHubDropdown;
